import { Features } from "@/store/features/features";
import { selectHasFeature } from "@/store/features/features-slice";
import { useAppSelector } from "@/store/store-hooks";
import { selectCanUseAiIndexing } from "@/store/subscription-features/subscription-features-selectors";
import { ToolGroup } from "@faro-lotv/flat-ui";
import { useState, type JSX } from "react";
import { OverlayToolbar } from "../overlay-toolbar";
import { AiBoundingBoxToggle } from "./ai-bounding-box-toggle";
import { MultiSheetTool } from "./multi-sheet-tool";
import { TagsFilterTool } from "./tags-filter-tool";
import { ViewOptionsTool } from "./view-options-tool";

/** @returns a toolbar that contains the tools to manage view settings */
export function ViewSettingsToolbar(): JSX.Element | null {
  const [toolbarRef, setToolbarRef] = useState<HTMLDivElement | null>(null);

  const isAiChatFeatureEnabled = useAppSelector(
    selectHasFeature(Features.AiChat),
  );
  const canUseAiIndexing = useAppSelector(selectCanUseAiIndexing);
  const isAiChatAllowed = isAiChatFeatureEnabled && canUseAiIndexing;

  return (
    <OverlayToolbar
      ref={setToolbarRef}
      sx={{ alignSelf: "flex-end", mt: 6 }}
      allowOverflow
    >
      <ToolGroup>
        <ViewOptionsTool anchorEl={toolbarRef} />
        <TagsFilterTool anchorEl={toolbarRef} />
        <MultiSheetTool anchorEl={toolbarRef} />
        {isAiChatAllowed && <AiBoundingBoxToggle />}
      </ToolGroup>
    </OverlayToolbar>
  );
}
